module.exports = __webpack_public_path__ + "static/img/logo.bfa58e78.png";